export default state => state.ui.mobileBanner;
